/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { BridgeMock } from 'crimson/lib/bridge/bridge.config';
import { Commands } from 'bridge-commands/commands';

export const SharedStorageMocks: BridgeMock[] = [
    { command: Commands.Common.Sharedstorage.Read, return: undefined },
    { command: Commands.Common.Sharedstorage.Write, return: undefined },
    { command: Commands.Common.Sharedstorage.Cache, return: undefined }
];
